export const GET_TOKEN = 'GET_TOKEN' ;
export const SET_TOKEN = 'SET_TOKEN' ;
export const HANDLE_MODAL = 'HANDLE_MOdAL' ;
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const HANDLE_SNACKBAR = 'HANDLE_SNACKBAR';
export const GET_OWNER = 'GET_OWNER';
export const GET_ROLE = 'GET_ROLE';
export const SET_ROLE = 'SET_ROLE';
export const GET_PERMISSION = 'GET_PERMISSION' ;
export const SET_PERMISSION = 'SET_PERMISSION' ;

export const GET_CURRENT_USER = 'GET_CURRENT_USER' ;
export const SET_CURRENT_USER = 'SET_CURRENT_USER' ;

export const HANDLE_MODAL_CONDITIONS = 'HANDLE_MODAL_CONDITIONS' ;
